import { parseISO } from 'date-fns';

/**
 * LocalStorage key for tracking since when the workload was never configured
 */
const WORKLOAD_NEVER_CONFIGURED_SINCE_KEY = 'workloadNeverConfiguredSince';

/**
 * Get the date since when the workload was never configured
 * @returns Date or null if workload has been configured
 */
export const getWorkloadNeverConfiguredSince = (): Date | null => {
    const dateString = localStorage.getItem(WORKLOAD_NEVER_CONFIGURED_SINCE_KEY);
    return dateString ? parseISO(dateString) : null;
};

/**
 * Set the date since when the workload was never configured
 * @param date - The date to store (typically current date)
 */
export const setWorkloadNeverConfiguredSince = (date: Date): void => {
    localStorage.setItem(WORKLOAD_NEVER_CONFIGURED_SINCE_KEY, date.toISOString());
};

/**
 * Clear the workload never configured flag (called when agent configures their workload)
 */
export const clearWorkloadNeverConfiguredSince = (): void => {
    localStorage.removeItem(WORKLOAD_NEVER_CONFIGURED_SINCE_KEY);
};
